import { createContext } from 'react'

export const PortalContext = createContext<Element | DocumentFragment | undefined>(undefined)

type PortalContextProviderProps = {
    children?: React.ReactNode
    container: Element | DocumentFragment
}

export function PortalContextProvider(props: PortalContextProviderProps) {
    return <PortalContext.Provider value={props.container}>{props.children}</PortalContext.Provider>
}
